"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const core_1 = require("@emotion/core");
const dashAnimation = core_1.keyframes `
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0px;
  };
  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px; 
  }
  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;
const spinAnimation = core_1.keyframes `
  100% {
    transform: rotate(360deg);
  };
`;
exports.styles = {
    circle: core_1.css `
    animation: ${dashAnimation} 1.4s ease-in-out infinite;
    stroke-dasharray: 80px, 200px;
    stroke-dashoffset: 0px;
    stroke: currentColor;
  `,
    root: core_1.css `
    animation: ${spinAnimation} 1.4s linear infinite;
  `,
    svg: core_1.css `
    border-radius: 50%;
    display: inline-block;
  `,
};
